/**
 * Central terminology reference for HoleScale
 * Phase 2: Standardize navigation labels. Always use "Supplier" (never "Vendor").
 */

export const TERMS = {
  // Core Platform Terms
  RFQ: 'RFQ',
  QUOTE: 'Quote',
  QUOTES: 'Quotes',
  ORDER: 'Order',
  ORDERS: 'Orders',
  SUPPLIER: 'Supplier',
  SUPPLIERS: 'Suppliers',
  BUYER: 'Buyer',
  BUYERS: 'Buyers',

  // Navigation Labels (Phase 2: consistent terminology)
  DASHBOARD: 'Dashboard',
  MY_RFQS: 'My RFQs',
  QUOTES_NAV: 'Quotes',
  ORDERS_NAV: 'Orders',
  SUPPLIERS_NAV: 'Suppliers',
  MY_SUPPLIERS: 'My Suppliers',
  FIND_SUPPLIERS: 'Find Suppliers',
  BROWSE_PRODUCTS: 'Browse Products',

  // Actions
  CREATE_RFQ: 'Create RFQ',
  VIEW_QUOTES: 'View Quotes',
  COMPARE_QUOTES: 'Compare Quotes',
  PLACE_ORDER: 'Place Order',
  ADD_INVENTORY: 'Add Inventory',

  // Status
  AWAITING_QUOTES: 'Awaiting Quotes',
  QUOTES_RECEIVED: 'Quotes Received',
  NO_QUOTES: 'No quotes yet',
} as const;

/**
 * Helper function to get plural form of a term
 */
export function pluralize(term: string, count: number): string {
  if (count === 1) return term;
  return term + 's';
}

/**
 * Helper function to format quote count text
 */
export function formatQuoteCount(count: number): string {
  if (count === 0) return TERMS.AWAITING_QUOTES;
  if (count === 1) return `View ${count} ${TERMS.QUOTE}`;
  return `View ${count} ${TERMS.QUOTES}`;
}

